import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { MktEmpty, Header } from '@cps'
import { memberMobx } from '@mobxStore'
import MemberApi from 'api/member.api'
import { useHistoryNew } from '@utils'
import { format } from '@dt/fe-utils'
import i18n from 'i18next'
import './index.scss'

import noCouponImg from '@img/no-coupon.png'

interface IProps extends IPage, RouteComponentProps { }

const pageSize: number = 12

const CouponRecordPage: FC<IProps> = () => {
  const history = useHistoryNew()
  const [canget, setCanget] = useState<boolean>(true)
  const [page, setPage] = useState<number>(1)
  const [logs, setLogs] = useState<any[]>([])
  // Data Method
  const getData = (pageNum: number, data: any[]) => {
    const para: any = {
      brandId: memberMobx.brandId,
      page: pageNum,
      limit: pageSize,
    }
    MemberApi.getCouponGiveLog(para).then((res: any) => {
      if (!res.error) {
        setLogs(data.concat(res.items))
        if (pageNum >= res.meta.totalPages) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }
  // Componeent Event
  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        setPage(page + 1)
        ev.target.complete()
      }, 500)
    }
  }
  // Component Effect
  useEffect(() => {
    getData(page, page === 1 ? [] : logs)
  }, [page])

  useIonViewWillEnter(() => {
    getData(1, [])
    setCanget(true)
    setPage(1)
  })
  return (
    <IonPage className='coupon-gift-record'>
      <Header title={i18n.t('mkt.giftCard.transferRecord')} onBack={() => history.goBack()}></Header>
      <IonContent className='page-content'>
        <div className='page-body'>
          {
            logs.length > 0
              ? (
                <div className='record-area'>
                  {
                    logs.map((item: any, index: number) => {
                      return (
                        <div data-cypid='mmgClickCoupon' className={`record-item${item.status === 'unAccept' ? ' un-accept' : ''}`} key={index} onClick={() => history.push(`/iCoupon/giftRecordDetail/${item.memberCouponGiveId}`)}>
                          <div className='top'>
                            <span>To {item.receiverName || i18n.t('mkt.coupon.wechatFriend')}</span>
                            <span className='top-time'>{format.toDateTime(item.addTime)}</span>
                          </div>
                          <div className='top'>
                            <span>{i18n.t('mkt.coupon.countTicketsInTotal', { count: item.memberCouponIds.length })}</span>
                            <span className={`${item.status === 'unAccept' ? 'unAccept' : ''}`}>
                              {item.status === 'accept' && i18n.t('mkt.coupon.received')}
                              {item.status === 'unAccept' && i18n.t('mkt.coupon.notReceivedAfterTransfer')}
                              {item.status === 'cancel' && i18n.t('mkt.coupon.transferCancel')}
                            </span>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>) : <MktEmpty img={noCouponImg}></MktEmpty>
          }
        </div>
        {
          canget &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponRecordPage)
